import http from '../../Common/api';
import generateQueryParamsUrl from '../../Common/utils/queryParamsGenerator';

import { businessUrl, partnersUrl, aggregatorsUrl } from './constants';
import {
  normalizeBusiness,
  normalizePartners,
  normalizeAggregators,
  normalizeBusinessReportsError,
} from './normalizers';

const getBusinessReports = async (filters = {}) => {
  try {
    const searchBy = generateQueryParamsUrl(businessUrl, filters);
    const businessReports = await http.get(searchBy);

    return normalizeBusiness(businessReports);
  } catch (error) {
    return normalizeBusinessReportsError(error);
  }
};

const getPartners = async () => {
  try {
    const partners = await http.get(partnersUrl);

    return normalizePartners(partners);
  } catch (error) {
    return [{ label: 'All', value: 'ALL' }];
  }
};

const getAggregators = async () => {
  try {
    const aggregators = await http.get(aggregatorsUrl);

    return normalizeAggregators(aggregators);
  } catch (error) {
    return [{ label: 'All', value: 'ALL' }];
  }
};

const getBusinessFilterOptions = async () => Promise.all([getPartners(), getAggregators()]);

export { getBusinessReports, getBusinessFilterOptions };
